export default __webpack_public_path__ + "static/media/david.aa48646f.png";